import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-[#0F1B2D] text-[#FAFAF5] py-20 px-6 md:px-12 overflow-hidden" data-id="element-89">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-90">
        {/* Left Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col gap-6" data-id="element-91">
          <h1 className="text-4xl md:text-6xl font-bold leading-tight tracking-tight" data-id="element-92">
            You Don't Need <span className="text-[#E8722A]" data-id="element-93">Followers</span>.{' '}
            <br data-id="element-94" />
            You Need <span className="text-[#E8722A]" data-id="element-95">Proof</span>.
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 font-medium" data-id="element-96">
            Get Your First Paid UGC Video in 7 Days — Even With 0 Followers, No
            Experience, and Just Your Phone.
          </p>

          <div className="prose prose-invert text-lg text-gray-400 leading-relaxed max-w-xl" data-id="element-97">
            <p data-id="element-98">
              You don't need to "blow up." You don't need to dance. You don't
              need perfect lighting, perfect skin, or a perfect personality.
            </p>
            <p className="mt-4" data-id="element-99">
              You need two things:{' '}
              <strong className="text-white" data-id="element-100">4 short videos</strong> that prove
              you can sell a product like a normal human. And a{' '}
              <strong className="text-white" data-id="element-101">daily pitching loop</strong> that
              gets your work in front of brands—on purpose.
            </p>
            <p className="mt-4 font-semibold text-[#E8722A]" data-id="element-102">
              That's what this Starter Kit gives you.
            </p>
          </div>

          <div className="mt-8" data-id="element-103">
            <a href="#pricing" className="inline-flex items-center justify-center gap-2 bg-[#E8722A] hover:bg-[#F59E0B] text-white font-bold text-lg px-8 py-4 rounded-full transition-all shadow-[0_0_20px_rgba(232,114,42,0.3)] hover:shadow-[0_0_30px_rgba(232,114,42,0.5)] transform hover:-translate-y-1" data-id="element-104">
              Get the UGC Starter Kit <ArrowRight className="w-5 h-5" data-id="element-105" />
            </a>
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative flex justify-center lg:justify-end" data-id="element-106">
          <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-107">
            {/* Glow effect behind image */}
            <div className="absolute inset-0 bg-[#E8722A] blur-[100px] opacity-20 rounded-full" data-id="element-108" />

            <img src="https://cdn.magicpatterns.com/uploads/f9Hv9SvQbxzkqHFUjuF7Qo/UGC-Starter-Kit-.png" alt="UGC Starter Kit on a tablet showing the cover" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-109" />
          </div>
        </motion.div>
      </div>
    </section>;
}